import { render, staticRenderFns } from "./ForgetPwd.vue?vue&type=template&id=7b3dfa17&"
import script from "./ForgetPwd.vue?vue&type=script&lang=js&"
export * from "./ForgetPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports